module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e02-bb0cb5bc0e5c7ac9a8b8048fcdf51491.jpg";